<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Create Recipes</h3>
              <h5
                v-if="coating_booth"
                class="mb-0"
              >
                for Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur">
            <HopperSelector
              v-model:selected_hopper="selected_hopper"
              :hoppers="hoppers"
              @update:selected_hopper="handleHopperSelection()"
            />
            <div
              v-if="selected_hopper"
              class="card-header row"
            >
              <h4>Recipe Name</h4>
              <input
                v-model="recipe.category"
                type="text"
                class="form-control mt-2 mb-2 px-2"
                :class="showRecipeNameError ? 'is-invalid' : ''"
                placeholder="Enter Recipe Name"
                @blur="validateRecipeName()"
              />
              <label
                v-if="showRecipeNameError"
                class="text-danger"
                style="font-size: 0.8rem"
              >
                Required field
              </label>
            </div>
            <div
              v-if="selected_hopper !== null"
              class="card-header row"
            >
              <div>
                <div
                  class="card-body"
                  style="padding-top: 0.2rem"
                >
                  <div class="table-responsive">
                    <h6>Side Reciprocators</h6>
                    <table class="table text-center table-sm">
                      <thead>
                        <tr>
                          <th class="small">Gun Name</th>
                          <th class="small">Powder Amount</th>
                          <th class="small">Gun Offset [%]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="gun in gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === false)"
                          :key="gun.gun_id"
                        >
                          <td class="small">
                            {{ gun.gun_name }}
                          </td>
                          <td class="small">
                            <span>
                              <input
                                v-model="gun.powder_amount_setting"
                                class="table-input-cell form-control form-control-sm mx-auto text-center"
                                type="number"
                                :placeholder="'Powder Amount'"
                                :step="0.1"
                                @blur="validatePowderAmountSetting(gun)"
                                @input="handleGunSettingChange(gun)"
                              />
                            </span>
                          </td>
                          <td class="small">
                            <span>
                              <input
                                v-model="gun.throughput_offset"
                                class="table-input-cell form-control form-control-sm mx-auto text-center"
                                type="number"
                                :placeholder="'Gun offset [%]'"
                                @input="handleGunSettingChange(gun)"
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="compute-section">
                      <soft-button
                        type="button"
                        :disabled="sideComputeDisabled"
                        :variant="sideComputeDisabled ? 'outline' : 'gradient'"
                        @click="computeTargetThroughput()"
                      >
                        {{
                          sideComputeDisabled
                            ? "Fill Powder Amounts to Compute Target Throughput"
                            : "Compute Target Throughput"
                        }}
                      </soft-button>
                      <MiniStatisticsCard
                        v-if="sideThroughputComputed"
                        title="Target throughput"
                        :value="`${recipe.target_throughput.toFixed(1)}`"
                        percentage=""
                        :icon="{ component: 'ni ni ni-support-16', background: 'bg-gradient-info' }"
                        class-content="px-2  "
                      />
                    </div>
                  </div>
                  <div v-if="coating_booth.reciprocator_side_bottom">
                    <h6 class="mt-4">Bottom Reciprocator</h6>
                    <div class="row mb-2"></div>
                    <div class="table-responsive">
                      <table class="table text-center table-sm">
                        <thead>
                          <tr>
                            <th class="small">Gun Name</th>
                            <th class="small">Powder Amount</th>
                            <th class="small">Gun Offset [%]</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="gun in gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === true)"
                            :key="gun.gun_id"
                          >
                            <td class="small">
                              {{ gun.gun_name }}
                            </td>
                            <td class="small">
                              <span>
                                <input
                                  v-model="gun.powder_amount_setting"
                                  class="table-input-cell form-control form-control-sm mx-auto text-center"
                                  type="number"
                                  :placeholder="'Powder amount setting'"
                                  @input="handleGunSettingChange(gun)"
                                />
                              </span>
                            </td>
                            <td class="small">
                              <span>
                                <input
                                  v-model="gun.throughput_offset"
                                  class="table-input-cell form-control form-control-sm mx-auto text-center"
                                  type="number"
                                  :placeholder="'Gun offset percentage [%]'"
                                  @input="handleGunSettingChange(gun)"
                                />
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="compute-section">
                        <soft-button
                          type="button"
                          :disabled="bottomComputeDisabled"
                          :variant="bottomComputeDisabled ? 'outline' : 'gradient'"
                          @click="computeTargetThroughputBottom()"
                        >
                          {{
                            bottomComputeDisabled
                              ? "Fill Powder Amounts to Compute Bottom Target Throughput"
                              : "Compute Bottom Target Throughput"
                          }}
                        </soft-button>
                        <MiniStatisticsCard
                          v-if="bottomThroughputComputed"
                          title="Target throughput bottom"
                          :value="`${recipe.target_throughput_bottom.toFixed(1)}`"
                          percentage=""
                          :icon="{ component: 'ni ni ni-support-16', background: 'bg-gradient-info' }"
                          class-content="px-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row mt-4">
                <soft-button
                  type="button"
                  color="secondary"
                  variant="gradient"
                  class="mb-0 me-2 js-btn-next"
                  style="min-width: 160px; max-width: 500px"
                  @click="
                    $router.push({
                      name: 'SteelCaseDashboard',
                      params: {
                        lineId: coating_booth.id,
                      },
                    })
                  "
                >
                  Go Back &nbsp; &nbsp;
                </soft-button>
                <soft-button
                  type="button"
                  class="mb-0 w-100"
                  style="min-width: 200px"
                  :disabled="saveButtonDisabled"
                  :variant="saveButtonDisabled ? 'outline' : 'gradient'"
                  @click="saveRecipeSettings()"
                >
                  Save Recipe Settings
                </soft-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import SoftButton from "@/components/SoftButton.vue";
import HopperSelector from "./components/HopperSelector.vue";
import MiniStatisticsCard from "@/components/MiniStatisticsCard.vue";

export default {
  name: "CreateRecipe",
  components: {
    SoftButton,
    HopperSelector,
    MiniStatisticsCard,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      coating_booth: {},
      hoppers: [],
      selected_hopper: null,
      hopperDropdownVisible: false,
      searchQueryHopper: "",
      gun_data: [],
      recipe: {
        category: "",
        target_throughput: null,
        target_throughput_bottom: null,
      },
      isRecipeNameValid: null,
    };
  },
  computed: {
    filteredHoppers() {
      return this.hoppers.filter(hopper => hopper.name.toLowerCase().includes(this.searchQueryHopper.toLowerCase()));
    },
    throughputsComputed() {
      if (this.coating_booth.reciprocator_side_bottom) {
        return this.recipe.target_throughput !== null && this.recipe.target_throughput_bottom !== null;
      } else {
        return this.recipe.target_throughput !== null;
      }
    },
    sideThroughputComputed() {
      return this.recipe.target_throughput !== null;
    },
    bottomThroughputComputed() {
      return this.recipe.target_throughput_bottom !== null;
    },
    bottomComputeDisabled() {
      if (!this.coating_booth.reciprocator_side_bottom) {
        return false;
      }
      const bottomGuns = this.gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === true);

      return bottomGuns.some(gun => !gun.powder_amount_setting);
    },
    sideComputeDisabled() {
      const sideGuns = this.gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === false);
      return sideGuns.some(gun => !gun.powder_amount_setting);
    },
    saveButtonDisabled() {
      return this.throughputsComputed === false || this.recipe.category === "";
    },
    showRecipeNameError() {
      return (this.recipe.category === "" && this.throughputsComputed) || this.isRecipeNameValid === false;
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    async getData() {
      await this.getCoatingBooth();
      this.gun_data = await this.getGunData();
      await this.getHoppers();
    },
    async getCoatingBooth() {
      try {
        const response = await axios.get("api/v1/steelcase/coatingbooth/" + this.lineId + "/");
        this.coating_booth = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getHoppers() {
      if (this.coating_booth.id === null) {
        return;
      }
      try {
        let response = await axios.get("api/v1/steelcase/hopper/coating-booth/" + this.coating_booth.id + "/");
        this.hoppers = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async checkBaggingExists() {
      try {
        const previous_baggings = (await axios.get("api/v1/steelcase/previous-baggings/" + this.coating_booth.id + "/"))
          .data;
        if (previous_baggings.length == 0) {
          this.$swal({
            title: "No previous baggings found",
            text: `No previous baggings found for Line "${this.coating_booth.name}". Perform bagging before creating a recipe.`,
            icon: "warning",
            confirmButtonText: "Go to Bagging",
          }).then(() => {
            this.$router.push({
              name: "Bagging",
              params: {
                lineId: this.coating_booth.id,
              },
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    validateRecipeName() {
      if (this.recipe.category.trim() === "") {
        this.isRecipeNameValid = false;
      } else {
        this.isRecipeNameValid = true;
      }
    },
    validatePowderAmountSetting(gun) {
      const setting = gun.powder_amount_setting;
      if (
        setting < this.coating_booth.min_powder_amount_setting ||
        setting > this.coating_booth.max_powder_amount_setting
      ) {
        gun.powder_amount_setting = null;
        this.$swal({
          title: "Invalid Powder Amount Setting",
          text: `Powder Amount Setting must be between ${this.coating_booth.min_powder_amount_setting} and ${this.coating_booth.max_powder_amount_setting}.`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    handleGunSettingChange(gun) {
      if (gun.is_gun_on_bottom_reciprocator && this.recipe.target_throughput_bottom !== null) {
        this.recipe.target_throughput_bottom = null;
      }
      if (!gun.is_gun_on_bottom_reciprocator && this.recipe.target_throughput !== null) {
        this.recipe.target_throughput = null;
      }
    },
    enrichGunData(gunData) {
      const gun = { ...gunData };
      gun.gun_id = gunData.id;
      gun.gun_name = gunData.name;
      gun.throughput_offset = null;
      gun.powder_amount_setting = null;

      return gun;
    },
    async getGunData() {
      try {
        const reponse = await axios.get(`api/v1/steelcase/guns/coating-booth/${this.coating_booth.id}/`);
        const guns = reponse.data;
        const enriched_guns = guns.map(gun => this.enrichGunData(gun));
        return enriched_guns.sort((a, b) => a.gun_index - b.gun_index);
      } catch (error) {
        console.error(error);
      }
    },
    handleHopperSelection() {
      this.checkBaggingExists();
      this.clearData();
    },

    prepareGunData(gun) {
      return {
        gun_id: gun.gun_id,
        powder_amount_setting: gun.powder_amount_setting,
        throughput_offset: gun.throughput_offset,
      };
    },
    async computeTargetThroughput() {
      const gun_data = this.gun_data
        .filter(gun => gun.is_gun_on_bottom_reciprocator === false)
        .map(gun => this.prepareGunData(gun));
      const response = await axios.post("api/v1/steelcase/computethroughputfrompowderamountsettings/", {
        gun_data: gun_data,
      });

      this.recipe.target_throughput = response.data.target_throughput;
    },
    async computeTargetThroughputBottom() {
      const gun_data = this.gun_data
        .filter(gun => gun.is_gun_on_bottom_reciprocator === true)
        .map(gun => this.prepareGunData(gun));
      const response = await axios.post("api/v1/steelcase/computethroughputfrompowderamountsettings/", {
        gun_data: gun_data,
      });

      this.recipe.target_throughput_bottom = response.data.target_throughput;
    },
    async createRecipe() {
      const payload = {
        hopper_id: this.selected_hopper.id,
        category: this.recipe.category,
        target_throughput: this.recipe.target_throughput,
        target_throughput_bottom: this.recipe.target_throughput_bottom,
      };
      const response = await axios.post("api/v1/steelcase/recipe/", payload);
      return response.data;
    },
    async calculateEqualizedPowderAmounts(recipeId) {
      const response = await axios.post("api/v1/steelcase/computerecipepowderamountsettingsfromtargetthroughput/", {
        recipe_id: recipeId,
        target_throughput: this.recipe.target_throughput,
        target_throughput_bottom: this.recipe.target_throughput_bottom,
      });
      return response.data;
    },
    async createPowderAmountSettings(recipeId, powder_amount_settings_by_gun_index) {

      const powderAmountSettingsPerGun = this.gun_data.map(gun => ({
        gun_id: gun.gun_id,
        powder_amount_setting: powder_amount_settings_by_gun_index[gun.gun_index].new_powder_amount_setting,
      })).filter(setting => setting.powder_amount_setting !== null && setting.powder_amount_setting !== undefined);

      await axios.post("api/v1/steelcase/createpowderamountsettingsbyrecipe/", {
        recipe_id: recipeId,
        powder_amount_settings_per_gun: powderAmountSettingsPerGun,
      });
    },
    async storeInferredGunCoefficientsAndStatus(recipeId, equalizedPowderAmountAndStatus) {
      console.log(equalizedPowderAmountAndStatus, recipeId);
      const diagnosisPerGun = {};
      this.gun_data.forEach(gun => {
        diagnosisPerGun[gun.gun_identifier] =
          equalizedPowderAmountAndStatus.powder_amount_settings_by_gun_index[gun.gun_index].diagnosis;
      });
      await axios.post("api/v1/steelcase/bulkupdateinferredcoefficientsandstatus/", {
        hopper_id: this.selected_hopper.id,
        gun_output_data: equalizedPowderAmountAndStatus.gun_output_data,
        diagnosis_per_recipe: { [recipeId]: diagnosisPerGun },
      });
    },
    async updateThroughputOffsets(recipeId) {
      const offsetsByGunIdData = {};
      this.gun_data.forEach(gun => {
        offsetsByGunIdData[gun.gun_id] = 1 + parseFloat(gun.throughput_offset) / 100;
      });

      await axios.post("api/v1/steelcase/target-throughput-offset/bulk-create-update/ ", {
        recipe_id: recipeId,
        offsets_by_gun_id: offsetsByGunIdData,
      });
    },
    async saveRecipeSettings() {
      try {
        const createdRecipe = await this.createRecipe();
        await this.updateThroughputOffsets(createdRecipe.id);
        const equalizedPowderAmountAndStatus = await this.calculateEqualizedPowderAmounts(createdRecipe.id);
        await this.createPowderAmountSettings(
          createdRecipe.id,
          equalizedPowderAmountAndStatus.powder_amount_settings_by_gun_index,
        );
        await this.storeInferredGunCoefficientsAndStatus(createdRecipe.id, equalizedPowderAmountAndStatus);

        this.$swal({
          title: "Success",
          text: `Recipe "${this.recipe.category}" saved successfully for hopper "${this.selected_hopper.name}".`,
          icon: "success",
          confirmButtonText: "Add Another Recipe",
          showCancelButton: true,
          cancelButtonText: "Go Back",
        }).then(result => {
          if (result.isConfirmed) {
            this.selected_hopper = null;
            this.clearData();
          } else if (result.isDismissed) {
            this.$router.push({
              name: "SteelCaseDashboard",
              params: {
                lineId: this.coating_booth.id,
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: `An error occurred while saving the recipe: ${error.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    clearData() {
      this.recipe = {
        category: "",
        target_throughput: null,
        target_throughput_bottom: null,
      };
      this.gun_data = this.gun_data.map(gun => {
        gun.powder_amount_setting = null;
        gun.throughput_offset = null;
        return gun;
      });
    },
  },
};
</script>
<style scoped>
.table-sm th,

.table-sm td {
  padding: 0.3rem;
  height: 2.2rem;
  vertical-align: middle;
}

.table thead th {
  text-transform: none;
}

.table-input-cell {
  width: 60%;
  padding: 0.75rem;
  height: 1.6rem;
  text-align: center;
  box-sizing: border-box;
  vertical-align: middle;
  background-color: transparent;
  border: 1px solid #a7a7a7; /* lighter gray */
}
.container-fluid {
  padding-top: 20px;
}

.compute-section {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: flex-start;
}

.compute-section > * {
  width: 50%;
}

.form-control {
  flex-shrink: initial;
  margin-right: 0.75rem;
  margin-left: 0.75rem;
}
</style>
